import React from 'react';
import { BrowserView, MobileView } from 'react-device-detect';
import FancySelect from "../elements/FancySelect/FancySelect";

const SpeedButtons = (props) => {

	return (
		<div className="speed-buttons">
			<BrowserView>
				<label className="input-label-styled">Please select your speed (mbps)</label>
				<div className="speed-btn-container">
					{props.speeds.map(value => {
						return (
							<div
								className={'speed-btn ' + (props.speed === value ? 'active' : '')}
								key={value}
								onClick={event => props.handleSpeedChange(value, event)}
							>
								{value}
							</div>
						);
					})}
				</div>
			</BrowserView>
			<MobileView>
				<div className="row">
					<div className="col-xs-12">
						<FancySelect
							title="Select your speed (Mbps)"
							list={props.speeds}
							setValue={props.handleSpeedChange.bind(this)}
						/>
					</div>
				</div>
			</MobileView>
		</div>
	);

};

export default SpeedButtons;




// WEBPACK FOOTER //
// ./resources/assets/js/modules/SpeedButtons.js